import { ContentWorkflowServiceHttpClient } from './httpClient';

export const updateContentWorklow = async (
  projectId,
  contentId,
  workflowAction
) => {
  const url = `/projects/${projectId}/workflow/${contentId}/${workflowAction}`;
  const response = await ContentWorkflowServiceHttpClient.post(url);

  return response.data;
};

export const shareContent = async (projectId, contentId) => {
  const url = `/projects/${projectId}/workflow/share/${contentId}`;
  const response = await ContentWorkflowServiceHttpClient.post(url);

  return response.data;
};
